module.exports = __webpack_public_path__ + "static/media/icon-site.64d65b59.svg";